var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneNavigationAppSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,0H9C7.3457031,0,6,1.3457031,6,3v26c0,1.6542969,1.3457031,3,3,3h14c1.6542969,0,3-1.3457031,3-3V3 C26,1.3457031,24.6542969,0,23,0z M9,2h14c0.5517578,0,1,0.4487305,1,1v23H8V3C8,2.4487305,8.4482422,2,9,2z M23,30H9 c-0.5517578,0-1-0.4487305-1-1v-1h16v1C24,29.5512695,23.5517578,30,23,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9267578,16H14v2.0727539C14,19.1352539,14.8642578,20,15.9267578,20 c0.7363281,0,1.3974609-0.4091797,1.7236328-1.0654297l4.1601562-8.3198242C21.9345703,10.3657227,22,10.0869141,22,9.809082 C22,8.8115234,21.1884766,8,20.1914062,8c-0.2792969,0-0.5595703,0.065918-0.8095703,0.190918l-8.3164062,4.1582031 C10.4082031,12.6777344,10,13.3383789,10,14.0727539C10,15.1352539,10.8642578,16,11.9267578,16z M19.7685547,10.2338867 L16,17.8520508V15c0-0.5522461-0.4472656-1-1-1h-2.7636719L19.7685547,10.2338867z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNavigationAppSmall);
export default __webpack_public_path__ + "static/media/phone-navigation-app--small.6141d14eaf756099f6d6273e5f57f3ae.svg";
export { ForwardRef as ReactComponent };